import * as types from "../service/types";

const InitState = {
  loading: false,
  profileData: "",
  error: "",
};
const ProfileInfoReducer = (state = InitState, action) => {
  switch (action.type) {
    case types.PROFILE_INFO_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.PROFILE_INFO_SUCCESS:
      return {
        loading: false,
        profileData: action.payload,
        error: "",
      };
    case types.PROFILE_INFO_ERROR:
      return {
        loader: false,
        profileData: "",
        error: action.error,
      };
    default:
      return state;
  }
};

export default ProfileInfoReducer;